"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoyaltyBehavior = void 0;
const external_1 = require("./external");
const growth_1 = require("./growth");
const internal_1 = require("./internal");
const resolve_1 = require("./resolve");
/**
 * Builds the behavior for the merchant's active provider.
 *
 * `provider` is the value resolved from the gateway configuration; `null` selects
 * internally managed loyalty, which needs no gateway access.
 */
const createLoyaltyBehavior = (provider, context) => {
    if (!provider) {
        return new internal_1.InternalLoyaltyBehavior();
    }
    if (provider === resolve_1.GROWTH_LOYALTY_PROVIDER) {
        return new growth_1.GrowthLoyaltyBehavior(context);
    }
    return new external_1.ExternalLoyaltyBehavior(context);
};
exports.createLoyaltyBehavior = createLoyaltyBehavior;
//# sourceMappingURL=factory.js.map